import { createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("ul", { class: "plains-list" }, [
  /*#__PURE__*/_createVNode("li", { class: "plains-list__item" }, "Новая командировка")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "Создание предложения", -1)
const _hoisted_3 = { class: "order-create-modal__tripType-wraper" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", { class: "avia-tarif-modal__title" }, "Данные предложения", -1)
const _hoisted_5 = { class: "order-create-modal-customer" }
const _hoisted_6 = { class: "order-create-modal-customer__item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", { class: "order-create-modal-customer__subtitle" }, "Название", -1)
const _hoisted_8 = { class: "order-create-modal-customer__item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", { class: "order-create-modal-customer__subtitle" }, "Компания", -1)
const _hoisted_10 = { class: "order-create-modal-customer__item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h3", { class: "order-create-modal-customer__subtitle" }, "Контракт", -1)
const _hoisted_12 = { class: "order-create-modal-customer__item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h3", { class: "order-create-modal-customer__subtitle" }, "Инициатор", -1)
const _hoisted_14 = { class: "order-create-modal-newsletter" }
const _hoisted_15 = { class: "order-create-modal-newsletter__controls" }
const _hoisted_16 = { class: "order-create-modal-newsletter__buttons-wrapper ml-a" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_main_loader = _resolveComponent("main-loader")
  const _component_InputText = _resolveComponent("InputText")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.localDisplay,
      "onUpdate:visible": _cache[12] || (_cache[12] = $event => (_ctx.localDisplay = $event)),
      dismissableMask: true,
      class: "p-dialog--hotels",
      modal: true
    }, {
      header: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_main_loader, { name: _ctx.names }, null, 8, ["name"])
        ]),
        _createVNode("div", null, [
          _hoisted_4,
          _createVNode("ul", _hoisted_5, [
            _createVNode("li", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.defaultOrder.businessTrip.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.defaultOrder.businessTrip.name = $event)),
                placeholder: "Введите название"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("li", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_AutoComplete, {
                minLength: 3,
                modelValue: _ctx.selectedClient,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.selectedClient = $event)),
                placeholder: "Выберите клиента",
                field: "entityName",
                suggestions: _ctx.lists.clients,
                onComplete: _cache[3] || (_cache[3] = $event => (
                _ctx.asyncFind($event, 'clients', _ctx.ActionTypesConstants.GET_CLIENT)
              )),
                onItemSelect: _cache[4] || (_cache[4] = $event => (_ctx.setData($event, 'clientId'))),
                disabled: !_ctx.defaultOrder.businessTrip.name,
                dropdown: true
              }, null, 8, ["modelValue", "suggestions", "disabled"])
            ]),
            _createVNode("li", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_AutoComplete, {
                modelValue: _ctx.selectedContract,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.selectedContract = $event)),
                placeholder: "Выберите контракт",
                minLength: 3,
                field: "entityName",
                suggestions: _ctx.lists.contracts,
                onComplete: _cache[6] || (_cache[6] = $event => (
                _ctx.asyncFind(
                  $event,
                  'contracts',
                  _ctx.ActionTypesConstants.GET_CONTRACT
                )
              )),
                onItemSelect: _cache[7] || (_cache[7] = $event => (_ctx.setData($event, 'contractId'))),
                disabled: !_ctx.defaultOrder.businessTrip.clientId,
                dropdown: true
              }, null, 8, ["modelValue", "suggestions", "disabled"])
            ]),
            _createVNode("li", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_AutoComplete, {
                modelValue: _ctx.selectedInitiator,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.selectedInitiator = $event)),
                placeholder: "Выберите инициатора",
                minLength: 3,
                field: "entityName",
                suggestions: _ctx.lists.initiators,
                onComplete: _cache[9] || (_cache[9] = $event => (
                _ctx.asyncFind(
                  $event,
                  'initiators',
                  _ctx.ActionTypesConstants.GET_INITIATOR
                )
              )),
                onItemSelect: _cache[10] || (_cache[10] = $event => (_ctx.setData($event, 'initiatorId'))),
                disabled: 
                !_ctx.defaultOrder.businessTrip.clientId ||
                  !_ctx.defaultOrder.businessTrip.contractId
              ,
                dropdown: true
              }, null, 8, ["modelValue", "suggestions", "disabled"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("button", {
                class: "order-create-modal-newsletter__btnAccept",
                onClick: _cache[11] || (_cache[11] = _withModifiers((...args) => (_ctx.sendOrder(...args)), ["prevent"])),
                disabled: !_ctx.isValid
              }, " Создать ", 8, ["disabled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}